import { HeadProvider } from 'react-head'
import 'react-toastify/dist/ReactToastify.css'
import { AppStylesProvider } from './components/AppStylesProvider'
import Router from './providers/Router.provider'
import ToastProvider from './providers/Toast.provider'
import PopupProvider from './providers/Popup.provider'
import RouteGuardProvider from './providers/RouteGuard.provider'
import ActionsProvider from './providers/Actions.provider'
import TanstackProvider from './providers/Tanstack.provider'
import { BrowserRouter } from 'react-router'
import Layout from './components/Layout'
import { AuthContextProvider } from './providers/AuthState.provider'
import { AppContextProvider } from './providers/AppState.provider'
import { ConfirmProvider } from './providers/Confirm.provider'
import LangProvider from './providers/Lang.provider'
import { FormProvider } from './providers/Form.provider'
import MediaProvider from './providers/Media.provider'
import MediaLibraryOutlet from './components/MediaLibraryOutlet'

const App = () => {
  return (
    <TanstackProvider>
      <AuthContextProvider>
        <LangProvider>
          <AppContextProvider>
            <ActionsProvider>
              <MediaProvider>
                <BrowserRouter>
                  <RouteGuardProvider>
                    <HeadProvider>
                      <AppStylesProvider>
                        <ToastProvider>
                          <PopupProvider>
                            <ConfirmProvider>
                              <FormProvider>
                                <Layout>
                                  <Router />
                                </Layout>
                              </FormProvider>
                            </ConfirmProvider>
                          </PopupProvider>
                        </ToastProvider>
                      </AppStylesProvider>
                    </HeadProvider>
                  </RouteGuardProvider>
                </BrowserRouter>
                <MediaLibraryOutlet />
              </MediaProvider>
            </ActionsProvider>
          </AppContextProvider>
        </LangProvider>
      </AuthContextProvider>
    </TanstackProvider>
  )
}

export default App
